// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_grid_hole_tray/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_grid_hole_tray: ModuleSchema = {
  "id": "core_grid_hole_tray",
  "uniqueId": "B3D_E4HRH",
  "createdAt": "2026-10-08T11:04:58.062Z",
  "updatedAt": "2026-10-08T14:06:49.703Z",
  "label": "Grid Tray",
  "description": "Reusable rounded tray with per-row well counts and diameters, blind wells, configurable edge margins, rounded mouths, and optional recessed exterior grooves.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_BTRY1",
    "grid",
    "organizer",
    "tray"
  ],
  "sliders": [
    {
      "key": "height",
      "label": "Tray Height",
      "min": 12,
      "max": 80,
      "step": 1,
      "default": 32,
      "unit": "mm"
    },
    {
      "key": "columns",
      "label": "Wells per Row",
      "min": 1,
      "max": 16,
      "step": 1,
      "default": 8
    },
    {
      "key": "rowCount",
      "label": "Number of Rows",
      "min": 1,
      "max": 16,
      "step": 1,
      "default": 5
    },
    {
      "key": "holeDiameter",
      "label": "Nominal Well Diameter",
      "min": 3,
      "max": 50,
      "step": 0.1,
      "default": 15,
      "unit": "mm"
    },
    {
      "key": "holeClearance",
      "label": "Hole Diametral Clearance",
      "min": 0,
      "max": 1.5,
      "step": 0.1,
      "default": 0.5,
      "unit": "mm"
    },
    {
      "key": "pitchX",
      "label": "Gap Between Wells Across Row",
      "min": 0,
      "max": 10,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "pitchY",
      "label": "Gap Between Well Rows",
      "min": 0,
      "max": 10,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "edgeMargin",
      "label": "Outer Margin Around Wells",
      "min": 3,
      "max": 25,
      "step": 0.5,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Outer Wall Thickness",
      "min": 1.2,
      "max": 10,
      "step": 0.2,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "floorThickness",
      "label": "Bottom Thickness",
      "min": 1.2,
      "max": 10,
      "step": 0.2,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "holeMouthRound",
      "label": "Hole Mouth Roundover",
      "min": 0,
      "max": 1.5,
      "step": 0.1,
      "default": 0.4,
      "unit": "mm"
    },
    {
      "key": "sideRibSpacing",
      "label": "Groove Spacing",
      "min": 2,
      "max": 12,
      "step": 0.5,
      "default": 5,
      "unit": "mm"
    },
    {
      "key": "sideRibWidth",
      "label": "Groove Width",
      "min": 0.5,
      "max": 4,
      "step": 0.1,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "sideRibDepth",
      "label": "Recessed Groove Depth (0 disables)",
      "min": 0,
      "max": 3,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [],
  "objects": [],
  "exportGroups": []
};
